import http from '@/libs/http'
export default class NormasRepartoServices {
  getNormasReparto () {
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/normas_reparto`)
  }
}
